// extracted by mini-css-extract-plugin
export var darkMode = "_2b-0";